import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ControlButton from '../../ui/ControlButton';
import { usePlayerContext } from '../../Context';
import { ControlsPosition, Events, State } from '../../../types/player';
import { StateChangedEvents } from '../../../sdk/PlayerEvents';
import ControlIcon from '../../ui/ControlIcon';

const Loading = () => {
  const { sdk } = usePlayerContext();
  const prefix = sdk.getClassNamePrefix();

  const [loading, setLoading] = useState<boolean>(false);

  let listeners: (() => void)[] = [];

  function checkLoading() {
    if (sdk.getCurrentState() == State.LOADING || sdk.getCurrentState() == State.IDLE || sdk.getCurrentState() == State.BUFFERING) {        
      setLoading(true);
    } else if (loading) {
      setLoading(false);
    }
  }

  useEffect(() => {
    
    listeners.push(sdk.on(Events.STATE_CHANGED, (event: StateChangedEvents) => {
      /*if (event.newState == State.LOADING || event.newState == State.IDLE || event.newState == State.BUFFERING) {        
        setLoading(true);
      } else if (loading) {
        setLoading(false);
      }*/
      checkLoading();
    }));

    checkLoading();

    return () => {
      listeners.forEach((listener) => listener());
    }

  }, [loading]);

  console.log('loading', loading);

  if (!loading) return null;

  return (
    <div className={`${prefix}-player-notification-loading`}>
      <ControlIcon iconName="spinner" spin={true} />
    </div>
  );
};

export default Loading;
